import { style, media } from 'typestyle'
export const mr8sm = style(media({ maxWidth: 576 }, { marginRight: '8px' }))
